function GettingStarted({lang}) {
    let locale = lang;
    return ( 
        <>
            <section className="container how-it-works" id="how-it-works">
                <h2 class="main-header">Getting started</h2>
                <h2 class="secondary-header">Registration</h2>


                <div className="flex-line">
                    <div className="flex-item">
                        <div className="phase">Phase 1</div>
                        <div className="point">
                            <div className="point-inside"></div>
                        </div>
                        <div className="on-line">1 week</div>
                        <div className="description">
                            <ul>
                                <li>Interview</li>
                                <li>Registration</li>
                            </ul>
                        </div>
                    </div>

                    <div className="flex-item">
                        <div className="phase">Phase 2</div>
                        <div className="point">
                            <div className="point-inside"></div>
                        </div>
                        <div className="on-line">1 week</div>
                        <div className="description">
                            <ul>
                                <li>Account activation</li>
                            </ul>
                        </div>
                    </div>


                    <div className="flex-item">
                        <div className="phase">Phase 3</div>
                        <div className="point">
                            <div className="point-inside"></div>
                        </div>
                        <div className="on-line">1 week</div>
                        <div className="description">
                            <ul>
                                <li>Recording session</li>
                                <li>Training</li>
                            </ul>
                        </div>
                    </div>

                    <div className="flex-item">
                        <div className="phase">Phase 4</div>
                        <div className="point">
                            <div className="point-inside"></div>
                        </div>
                        <div className="on-line">1 week</div>
                        <div className="description">
                            <ul>
                                <li>Onlyfans account promotion</li>
                            </ul>
                        </div>
                    </div>

                    <div className="flex-item">
                        <div className="wrapped">
                            <p>
                            Go viral 🎉
                            </p>
                        </div>
                    </div>

                </div>
            </section>
        </>
     );
}

export default GettingStarted;